import { capitalizeFirstLetter } from 'commonComponents/FirstLetterCaptial'
import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { convertDateDDMMYYYY } from 'utils/dateConvertor';

import Chip from '@mui/material/Chip';
import DeleteConfirmationModal from 'commonComponents/DeleteConirmationModel';
import { useDispatch, useSelector } from 'react-redux';
import { deleteCompanyById } from '../redux/dispatcher';

// Single Row Data Reperesent Component
function RowData({ itemInfo, handleEdit, handleDelete, handleView, currentPage, rowsPerPage }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [itemId, setItemId] = useState(null);

    const dispatch = useDispatch()
    const {data} = useSelector((state)=>state.authReducer);
    const {isLoading} = useSelector((state)=>state.companyListReducer);

    const toggleModal = () => setModalOpen(!modalOpen);

    const handleDeleteClick = (id) => {
        setItemId(id); // Set the id to be deleted
        toggleModal(); // Open the modal
      };

    const handleDeleteConfirm =  () => {
        const payload = {
            id:itemInfo?.id,
            currentPage,
            rowsPerPage
        }
        dispatch(deleteCompanyById(payload, toggleModal))  
      };
    return (
        <>
            <tbody>
                <tr className="align-items-center text-center" >
                    <td>{itemInfo?.serial_number}</td>
                    <td>{itemInfo?.company_name}</td>
                    <td>{itemInfo?.first_name} {itemInfo?.last_name}</td>
                    <td>{itemInfo?.contact_person_name}</td>
                    <td>{itemInfo?.contact_number || '-'}</td>
                    <td>{convertDateDDMMYYYY(itemInfo?.contract_end_date) || '-'}</td>

                    <td>{itemInfo?.water_cost || '-'}</td>
                    <td className={itemInfo.status === 'active' ? 'text-success' : 'text-danger'}>
                        {
                            itemInfo?.status === 'active' ? <Chip label={capitalizeFirstLetter(itemInfo?.status)} color="success" sx={{ p: 1 }} /> : <Chip label={capitalizeFirstLetter(itemInfo?.status)} color="error" />
                        }

                    </td>
                    <td style={{ padding: '0px' }}>
                        {/* <div className='d-flex d-flex justify-content-around'> */}
                        <div>

                            {/* <button disabled={itemInfo?.isDisabled} style={buttonStyles} onClick={() => handleEdit(itemInfo.id)}>
                                <FontAwesomeIcon icon={faPen} className={itemInfo?.isDisabled ? 'icon_disabled' : 'icon_hover'} />
                            </button> */}


                            {
                                itemInfo?.isDisabled ? <>
                                    {/* <Button color="danger" disabled={true}>
                                        <i class="fa-solid fa-eye"></i>
                                    </Button>
                                    <Button color="danger" disabled={true}>
                                        <i class="fa-solid fa-pen "></i>
                                    </Button> */}
                                </> : <>
                                    <i className="fa-solid fa-eye icon_hover" onClick={() => handleView(itemInfo.id)} style={{ marginRight: '16px' }}></i>
                                    <button disabled={itemInfo?.isDisabled} style={{ border: 'none', background: 'transparent', color: 'black' }} onClick={() => handleEdit(itemInfo.id)}>
                                        <i className={itemInfo?.isDisabled ? 'fa-solid fa-pen icon_disabled' : ' fa-solid fa-pen icon_hover'}></i>
                                    </button>
                                    {
                                        data?.user?.role === "super_admin" && (
                                        <i className="fa-solid fa-trash icon_hover ml-3 mr-3" onClick={() => handleDeleteClick(itemInfo?.uuid)}></i>
                                        )
                                    }
                                </>
                            }


                        </div>
                    </td>
                </tr>
            </tbody>
            <DeleteConfirmationModal
            isOpen={modalOpen}
            toggle={toggleModal}
            onConfirm={handleDeleteConfirm}
            itemName={`company`}
            isLoading={isLoading}
            />
        </>
    )
}

export default RowData
